import { formatUTCTimestamp } from "../../utils/DateFormatter";
import { isRadianMetric } from "../../utils/AngleConverter";

export default function CustomTooltip({ active, payload, label }: any) {
  function formatValue(value: number, dataKey: string) {
    // Check if this is a converted angle value (ends with _deg)
    if (dataKey && dataKey.endsWith('_deg')) {
      return `${value.toFixed(1)}°`;
    }
    return value.toFixed(2);
  }

  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip background-color silver-border">
        <p className="tooltip-label">{`${label}`}</p>
        {payload.map((item: any, index: number) => (
          <p
            key={`item-${index}`}
            className="tooltip-value"
            style={{ color: item.color }}
          >{`${item.name}: ${formatValue(item.value, item.dataKey)}`}</p>
        ))}
      </div>
    );
  }

  return null;
}
